import axios from "axios";

const payment = {

    camping(params) {
        return axios.post(`${process.env.API1}/api/camping/register`, params);
    },
    saveOrder(params) {
        return axios.post(`${process.env.API1}/api/order/register`, params);
    },
}

export default payment



// WEBPACK FOOTER //
// ./src/services/payment.service.js